"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidIp = void 0;
var isValidIp = function (ip) {
    return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip);
};
exports.isValidIp = isValidIp;
